export default {
  'shippingOptions.list.newShipment': 'New Shipment',
  'shippingOptions.list.title': 'Title',
  'shippingOptions.list.subject': 'Subject',
  'shippingOptions.list.action': 'Action',

  'shippingOptions.remove': 'Remove shipping options',
  'shippingOptions.remove.alert':
    'Do you really want to remove the shipping options:',
  'shippingOptions.remove.notification.success': 'Success',
  'shippingOptions.remove.notification.successDescription':
    'Shipping options removed',

  'shippingOptions.emailMontage.title': 'Title',
  'shippingOptions.emailMontage.company': 'Company',
  'shippingOptions.emailMontage.subject': 'Subject',
  'shippingOptions.emailMontage.quiz': 'Quiz',

  'shippingOptions.buttons.next': 'Save and Continue',
  'shippingOptions.buttons.finish': 'Finish',
};
